import React from 'react';
import { Formik, Form, Field } from 'formik';
import { WizardContext } from 'react-albus';
import { householdIncomeValidation } from '../validations';
import { saveItem, getExistingData } from '../helper';
import FormikMaskedInput from '../../CommonComponents/FormikMaskedInput';
import { currencyMask } from '../../CommonComponents/MaskedInput';
import Header from '../Components/Header';
import WizardProgress from '../Components/WizardProgress';

interface Props {
  wizard: WizardContext;
}

const HouseholdIncome: React.FC<Props> = ({ wizard }) => {
  const { next } = wizard;
  const { HouseholdIncome } = getExistingData();

  return (
    <div id="ExpressWizard_Input_Retirement" className="adv-form ExpressWizard">
      <Header wizard={wizard} />
      <WizardProgress wizard={wizard} />

      <Formik
        initialValues={{
          HouseholdIncome: HouseholdIncome || '',
        }}
        validationSchema={householdIncomeValidation}
        onSubmit={values => {
          saveItem(values);
          next();
        }}
        render={({ errors, touched }) => (
          <Form>
            <ul className="questions">
              <li style={{ display: 'block' }}>
                <ul className="horizontal-layout">
                  <li>
                    <label>Annual Household Income</label>
                    <div
                      className={`input underline ${
                        errors.HouseholdIncome && touched.HouseholdIncome ? 'invalid' : ''
                      }`}
                      style={{ minWidth: '240px' }}
                    >
                      <i style={{ marginRight: '10px' }}>$</i>
                      <Field
                        className="input-container"
                        name="HouseholdIncome"
                        component={FormikMaskedInput}
                        mask={currencyMask}
                        placeholder="0"
                        style={{ width: '200px' }}
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="action">
              <button type="submit" className="primary flat next">
                Next
              </button>
            </div>
          </Form>
        )}
      />
    </div>
  );
};

export default HouseholdIncome;
